import { X, Eye, EyeOff, User, Mail, Lock, Loader2 } from "lucide-react";

// add modal
export const AddUserModal = ({
  fname,
  lname,
  email,
  role,
  products,
  permissions,
  availableProducts,
  availablePermissions,
  status,
  onChangeFName,
  onChangeLName,
  onChangeEmail,
  onChangeRole,
  onToggleProduct,
  handlePermissionToggle,
  onChangeStatus,
  onClose,
  handleSubmit,
  message2,
  firstNameError,
  lastNameError,
  organization,
  onChangeOrganization,
}) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 sm:p-4 z-50">
    <div className="bg-white rounded-lg w-full max-w-2xl max-h-[95vh] overflow-y-auto mx-2 sm:mx-0">
      <form onSubmit={handleSubmit}>
        {/* Header */}
        <div className="p-4 sm:p-6 border-b border-gray-400 flex items-center justify-between sticky top-0 bg-white z-10">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
            Add User
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 p-1"
            aria-label="Close modal"
          >
            <X className="h-5 w-5 sm:h-6 sm:w-6" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4 sm:p-6 space-y-4 sm:space-y-6">
          {/* Basic Info */}
          <div className="grid grid-cols-1 gap-3 sm:gap-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                  First Name<span className="text-red-500 ms-1">*</span>
                </label>
                <div className="relative">
                  <User className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 h-4 w-4 sm:h-5 sm:w-5" />
                  <input
                    type="text"
                    placeholder="John"
                    value={fname}
                    onChange={onChangeFName}
                    className="w-full pl-8 sm:pl-10 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    required
                  />
                </div>
                {firstNameError && firstNameError.type === "error" && (
                  <div className="text-xs sm:text-sm text-red-600 mt-1">
                    {firstNameError.text}
                  </div>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                  Last Name<span className="text-red-500 ms-1">*</span>
                </label>
                <div className="relative">
                  <User className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 h-4 w-4 sm:h-5 sm:w-5" />
                  <input
                    type="text"
                    placeholder="Doe"
                    value={lname}
                    onChange={onChangeLName}
                    className="w-full pl-8 sm:pl-10 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    required
                  />
                </div>
                {lastNameError && lastNameError.type === "error" && (
                  <div className="text-xs sm:text-sm text-red-600 mt-1">
                    {lastNameError.text}
                  </div>
                )}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                Email<span className="text-red-500 ms-1">*</span>
              </label>
              <div className="relative">
                <Mail className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 h-4 w-4 sm:h-5 sm:w-5" />
                <input
                  type="email"
                  placeholder="doctor@hospital.com"
                  value={email}
                  onChange={onChangeEmail}
                  className="w-full pl-8 sm:pl-10 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
              </div>
              {message2 && message2.type === "error" && (
                <div className="text-xs sm:text-sm text-red-600 mt-1">
                  {message2.text}
                </div>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                Organization<span className="text-red-500 ms-1">*</span>
              </label>
              <input
                type="text"
                placeholder="General Hospital"
                value={organization}
                onChange={onChangeOrganization}
                className="w-full px-3 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            {/* Role and Status */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                  Role<span className="text-red-500 ms-1">*</span>
                </label>

                <select
                  value={role}
                  onChange={onChangeRole}
                  className="w-full px-3 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer"
                  required
                >
                  <option value="2">Admin</option>
                  <option value="1">User</option>
                  <option value="4">Scribe Full-time</option>
                  <option value="3">Scribe Part-time</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                  Status<span className="text-red-500 ms-1">*</span>
                </label>
                <select
                  value={status}
                  onChange={onChangeStatus}
                  className="w-full px-3 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer"
                  required
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </select>
              </div>
            </div>

            {/* Product Access and Permissions */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2 sm:mb-3">
                  Product Access
                </label>
                <div className="space-y-1 sm:space-y-2">
                  {availableProducts.map((product) => (
                    <label key={product} className="flex items-center">
                      <input
                        type="checkbox"
                        checked={products.includes(product)}
                        onChange={() => onToggleProduct(product)}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <span className="ml-2 text-sm text-gray-700">
                        {product}
                      </span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Permissions */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2 sm:mb-3">
                  Permissions
                </label>
                <div className="space-y-1 sm:space-y-2">
                  {availablePermissions.map((permission) => (
                    <label key={permission} className="flex items-center">
                      <input
                        type="checkbox"
                        checked={permissions.includes(permission)}
                        onChange={() => handlePermissionToggle(permission)}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                      />
                      <span className="ml-2 text-sm text-gray-700 capitalize">
                        {permission}
                      </span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 sm:p-6 border-t border-gray-200 flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 sticky bottom-0 bg-white">
          <button
            type="button"
            className="px-3 sm:px-4 py-2 border-2 border-gray-400 rounded-lg text-gray-700 hover:bg-gray-50 text-sm sm:text-base"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-3 sm:px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 flex items-center justify-center gap-2 text-sm sm:text-base"
          >
            Add User
          </button>
        </div>
      </form>
    </div>
  </div>
);
// Delete Modal - Responsive
export const DeleteUserModal = ({ cancelDelete, confirmDelete, deleting = false }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 sm:p-4 z-50">
      <div className="bg-white rounded-lg max-w-sm w-full mx-2 sm:mx-0 shadow-xl">
        <div className="p-4 sm:p-6">
          <div className="flex items-center justify-between mb-3 sm:mb-4">
            <h3 className="text-lg font-semibold text-gray-900">Delete User</h3>
            <button
              onClick={cancelDelete}
              disabled={deleting}
              className="text-gray-400 hover:text-gray-600 p-1 disabled:opacity-50 disabled:cursor-not-allowed"
              aria-label="Close modal"
            >
              <X className="h-5 w-5 sm:h-6 sm:w-6" />
            </button>
          </div>
          <p className="text-gray-600 text-sm sm:text-base mb-4 sm:mb-6">
            Are you sure you want to delete this user? This action cannot be
            undone.
          </p>

          <div className="flex flex-col sm:flex-row justify-end gap-2 sm:gap-3">
            <button
              onClick={cancelDelete}
              disabled={deleting}
              className="px-3 sm:px-4 py-2 border-2 border-gray-400 rounded-lg text-gray-700 hover:bg-gray-50 text-sm sm:text-base order-2 sm:order-1 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Cancel
            </button>
            <button
              onClick={confirmDelete}
              disabled={deleting}
              className="px-3 sm:px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 text-sm sm:text-base order-1 sm:order-2 inline-flex items-center justify-center gap-2 disabled:opacity-80 disabled:cursor-wait min-w-[7rem]"
            >
              {deleting && <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />}
              {deleting ? "Deleting" : "Delete"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const UpdateUserModal = ({
  fname,
  lname,
  email,
  role,
  status,
  onChangeFName,
  onChangeLName,
  onChangeEmail,
  onChangeRole,
  onChangeStatus,
  onClose,
  handleSubmit,
  firstNameError,
  lastNameError,
}) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 sm:p-4 z-50">
    <div className="bg-white rounded-lg w-full max-w-2xl max-h-[95vh] overflow-y-auto mx-2 sm:mx-0">
      <form onSubmit={handleSubmit}>
        <div className="p-4 sm:p-6 border-b border-gray-400 flex items-center justify-between sticky top-0 bg-white z-10">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
            Update User
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 p-1"
            aria-label="Close modal"
          >
            <X className="h-5 w-5 sm:h-6 sm:w-6" />
          </button>
        </div>

        <div className="p-4 sm:p-6 space-y-4 sm:space-y-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                First Name<span className="text-red-500 ms-1">*</span>
              </label>
              <div className="relative">
                <User className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 h-4 w-4 sm:h-5 sm:w-5" />
                <input
                  type="text"
                  placeholder="John"
                  value={fname}
                  onChange={onChangeFName}
                  className="w-full pl-8 sm:pl-10 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
              </div>
              {firstNameError && firstNameError.type === "error" && (
                <div className="text-xs sm:text-sm text-red-600 mt-1">
                  {firstNameError.text}
                </div>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                Last Name<span className="text-red-500 ms-1">*</span>
              </label>
              <div className="relative">
                <User className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 h-4 w-4 sm:h-5 sm:w-5" />
                <input
                  type="text"
                  placeholder="Doe"
                  value={lname}
                  onChange={onChangeLName}
                  className="w-full pl-8 sm:pl-10 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
              </div>
              {lastNameError && lastNameError.type === "error" && (
                <div className="text-xs sm:text-sm text-red-600 mt-1">
                  {lastNameError.text}
                </div>
              )}
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">
              Email<span className="text-red-500 ms-1">*</span>
            </label>
            <div className="relative">
              <Mail className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 h-4 w-4 sm:h-5 sm:w-5" />
              <input
                type="email"
                placeholder="doctor@hospital.com"
                value={email}
                onChange={onChangeEmail}
                className="w-full pl-8 sm:pl-10 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                required
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                Role<span className="text-red-500 ms-1">*</span>
              </label>

              <select
                value={role}
                onChange={onChangeRole}
                className="w-full px-3 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer"
                required
              >
                <option value="2">Admin</option>
                <option value="1">User</option>
                <option value="4">Scribe Full-time</option>
                <option value="3">Scribe Part-time</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                Status<span className="text-red-500 ms-1">*</span>
              </label>
              <select
                value={status}
                onChange={onChangeStatus}
                className="w-full px-3 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent cursor-pointer"
                required
              >
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>
          </div>
        </div>

        {/* Product Access */}
        {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

           <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">Product Access</label>
              <div className="space-y-2">
                {availableProducts.map((product) => (
                  <label key={product} className="flex items-center">
                    <input
                      type="checkbox"
                      checked={products.includes(product)}
                      onChange={() => onToggleProduct(product)}
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <span className="ml-2 text-sm text-gray-700">{product}</span>
                  </label>
                ))}

              </div>
            </div> */}

        {/* Permissions */}
        {/* <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">Permissions</label>
              <div className="space-y-2">
                {availablePermissions.map((permission) => (
                  <label key={permission} className="flex items-center">
                    <input
                      type="checkbox"
                      checked={permissions.includes(permission)}
                      onChange={() => handlePermissionToggle(permission)}
                      className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    />
                    <span className="ml-2 text-sm text-gray-700 capitalize">{permission}</span>
                  </label>
                ))}
              </div>
            </div> 
          </div>
        </div>*/}
        <div className="p-4 sm:p-6 border-t border-gray-200 flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 sticky bottom-0 bg-white">
          <button
            type="button"
            className="px-3 sm:px-4 py-2 border-2 border-gray-400 rounded-lg text-gray-700 hover:bg-gray-50 text-sm sm:text-base"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-3 sm:px-4 py-2 bg-gradient-to-r from-blue-600 to-teal-600 text-white rounded-lg hover:shadow-lg transition-all duration-200 text-sm sm:text-base"
          >
            Update
          </button>
        </div>
      </form>
    </div>
  </div>
);

// Password Update Modal - Responsive
export const PasswordUpdateModal = ({
  password,
  confirmPassword,
  onChangePassword,
  onChangeConfirmPassword,
  onClose,
  handleSubmit,
  message1,
  showPassword,
  togglePasswordVisibility,
  showConfirmPassword,
  toggleConfirmPasswordVisibility,
}) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-2 sm:p-4 z-50">
    <div className="bg-white rounded-lg w-full max-w-2xl max-h-[95vh] overflow-y-auto mx-2 sm:mx-0">
      <form onSubmit={handleSubmit}>
        <div className="p-4 sm:p-6 border-b border-gray-400 flex items-center justify-between sticky top-0 bg-white z-10">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-900">
            Update Password
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 p-1"
            aria-label="Close modal"
          >
            <X className="h-5 w-5 sm:h-6 sm:w-6" />
          </button>
        </div>

        <div className="p-4 sm:p-6 space-y-4 sm:space-y-6">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                Password<span className="text-red-500 ms-1">*</span>
              </label>
              <div className="relative">
                <Lock className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 h-4 w-4" />
                <input
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={password}
                  onChange={onChangePassword}
                  className="w-full pl-8 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
                <button
                  type="button"
                  onClick={togglePasswordVisibility}
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 p-1"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                </button>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1 sm:mb-2">
                Confirm Password<span className="text-red-500 ms-1">*</span>
              </label>
              <div className="relative">
                <Lock className="absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-500 h-4 w-4" />
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={onChangeConfirmPassword}
                  className="w-full pl-8 py-2 text-sm sm:text-base border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  required
                />
                <button
                  type="button"
                  onClick={toggleConfirmPasswordVisibility}
                  className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 p-1"
                  aria-label={
                    showConfirmPassword ? "Hide password" : "Show password"
                  }
                >
                  {showConfirmPassword ? (
                    <EyeOff size={16} />
                  ) : (
                    <Eye size={16} />
                  )}
                </button>
              </div>
              {message1 && message1.type === "error" && (
                <div className="text-xs sm:text-sm text-red-600 mt-1">
                  {message1.text}
                </div>
              )}
            </div>
          </div>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
            <div className="text-xs sm:text-sm text-amber-800 text-center">
              Requirements: 8+ characters, lowercase, uppercase, number, special
              characters
            </div>
          </div>
        </div>

        <div className="p-4 sm:p-6 border-t border-gray-200 flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 sticky bottom-0 bg-white">
          <button
            type="button"
            className="px-3 sm:px-4 py-2 border-2 border-gray-400 rounded-lg text-gray-700 hover:bg-gray-50 text-sm sm:text-base"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-3 sm:px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 text-sm sm:text-base"
          >
            Update Password
          </button>
        </div>
      </form>
    </div>
  </div>
);
